/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInvoiceProcessingProfile.ts      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/invoice-processing-profile";

export class AutogenModelInvoiceProcessingProfile<RowType extends ModelRow> extends Endpoint<RowType, RowInvoiceProcessingProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInvoiceProcessingProfile extends ModelRow<RowInvoiceProcessingProfileFields> {
	constructor(values?: Partial<RowInvoiceProcessingProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInvoiceProcessingProfileFields {
	agent_exclude: string;
	agents: string;
	bill_status: string;
	bill_type: string;
	billing_user_id_exclude: string;
	billing_user_ids: string;
	by_booking_number: string;
	company_id: string;
	customer_categories: string;
	customer_category_exclude: string;
	customer_id_exclude: string;
	customer_ids: string;
	enable_settlement_transfer: string;
	id: string;
	invoice_processor_exclude: string;
	invoice_processor_ids: string;
	is_intercompany: string;
	order_allocation_exclude: string;
	order_allocations: string;
	order_type_exclude: string;
	order_types: string;
	profile_color: string;
	rate_origin: string;
	revenue_code_exclude: string;
	revenue_codes: string;
	title: string;
}

